<ng-template let-entity="entity" #actionsTemplate>
  <!--<a class="btn btn-yellow" ngbTooltip="PDF Dokument als E-Mail versenden" *ngIf="config?.isSendButtonVisible && permissions?.evaluationDeliveryNotesSend" (click)="sendPdfEmail(entity)">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-send">
      <line x1="22" y1="2" x2="11" y2="13"></line>
      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
    </svg>
  </a>

  <a class="btn btn-yellow ms-1" ngbTooltip="Als PDF Dokument herunterladen" (click)="downloadPdf(entity)">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download">
      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
      <polyline points="7 10 12 15 17 10"></polyline>
      <line x1="12" y1="15" x2="12" y2="3"></line>
    </svg>
  </a>-->
</ng-template>

<ng-template #content>
  <div class="clearfix">
    <form class="float-start">
      <div i18n="@@Search" style="min-width:200px;">
        <input class="form-control" id="table_search" type="text" name="searchTerm" [(ngModel)]="tableFunctions.searchTerm" i18n-placeholder="@@SearchAll" placeholder="Alles durchsuchen..." />
      </div>
    </form>
    <div class="float-end mb-3">
      <button type="button" class="btn btn-yellow" [routerLink]="['settings']" *ngIf="this.authenticationService.userHasRole('Customer')">
        <app-svg source="icons/feather/sliders" height="18"></app-svg>
        <span class="d-md-inline ps-1">Einstellungen</span>
      </button>
      <button type="button" class="btn btn-yellow" [routerLink]="['../delivery-notes/settings']" *ngIf="this.authenticationService.userHasRole('Operator')">
        <app-svg source="icons/feather/sliders" height="18"></app-svg>
        <span class="d-md-inline ps-1">Einstellungen</span>
      </button>
    </div>
    </div>
    <div *ngIf="tableReady">
      <app-table [table]="table"></app-table>
    </div>
    <div *ngIf="!tableReady" class="loading-spinner-container">
      <div class="spinner-border text-primary loading-spinner-md" role="status">
        <span class="visually-hidden-focusable" i18n="@@Loading">Loading...</span>
      </div>
    </div>
</ng-template>

<ng-template #operatorView>
  <div class="card-body">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
</ng-template>

<ng-template #customerView>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>

<ng-template #userView>
  <main id="delivery-notes">
    <div class="card">
      <nav>
        <div class="nav-tab" id="nav-tab" role="tablist">
          <ul ngbNav #nav="ngbNav" [activeId]="activeTab" class="nav-tabs nav-pills">
            <li class="nav-item" [ngbNavItem]="'summary'" domId="tab_deliverynote">
              <a class="nav-link me-2 ps-2" ngbNavLink disabled>
                <app-svg source="icons/feather/file-text" height="18"></app-svg>
                <span i18n="@@DeliverynoteTab">Lieferscheine</span>
              </a>
            </li>
          </ul>
        </div>
      </nav>

      <div class="card-body">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
  
      <div class="card-footer" [ngStyle]="{'display': componentSettings.footerVisible == true ? 'block' : 'none' }">
        <div class="d-flex">
          <div class="flex-fill d-none d-md-inline">
            <div class="d-flex">
              <div class="flex p-2" i18n="@@ElementsPerPage">Elemente pro Seite</div>
              <div class="flex">
                <select id="pageSize" name="pageSize" [(ngModel)]="tableFunctions.pageSize" class="form-control form-select custom-select" aria-label="" (change)="tableFunctions.onPageSizeChange(className)">
                  <option [ngValue]="10">10</option>
                  <option [ngValue]="25">25</option>
                  <option [ngValue]="50">50</option>
                  <option [ngValue]="100">100</option>
                  <option [ngValue]="250">250</option>
                </select>
              </div>
            </div>
          </div>
          <div class="d-flex d-md-inline-flex flex-fill text-center justify-content-center">
            <ngb-pagination #pagination
                            [collectionSize]="(tableFunctions.total$ | async)!"
                            [(page)]="tableFunctions.page"
                            [pageSize]="tableFunctions.pageSize"
                            [maxSize]="tableFunctions.page == 4 ? 4 : 3"
                            [boundaryLinks]="true"
                            [rotate]="true">
            </ngb-pagination>
          </div>
          <div class="flex-fill justify-content-end d-none d-md-inline">
            <div class="d-flex float-end">
              <div class="flex p-2" i18n="@@GoToPage">Springe zu Seite</div>
              <div class="flex">
                <select id="page" name="page" [(ngModel)]="tableFunctions.page" class="form-control form-select" aria-label="">
                  <option *ngFor="let page of [].constructor(pagination.pageCount); let i = index" [ngValue]="i + 1">{{ i + 1 }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</ng-template>

<ng-container *ngTemplateOutlet="determineTemplate()"></ng-container>

<router-outlet></router-outlet>
